'use client';

import { OperationsFilterAlt } from '@energy-retailer/icons';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { BaseModalContent, Modal, ModalButton } from '@/components/modal';
import { Text } from '@/components/text';

import { DistributorField } from './distributor-field';

import type { FilteringSchemaType } from './form-schema';
import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';

const DistributorFilterModal = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { watch } = useFormContext<FilteringSchemaType>();

  const { property:{electricityDistributors, gasDistributors} } = useJoinFormStore();

  const combinedDistributors = [...electricityDistributors, ...gasDistributors];

  const distributor = watch('distributor');

  function closeModal() {
    setIsModalOpen(false);
  }

  function openModal() {
    setIsModalOpen(true);
  }

  const distributorName = combinedDistributors.find(
    (value) => value.id === distributor
  )?.name;

  return (
    <>
      <button
        type="button"
        onClick={openModal}
        className="flex items-center justify-between max-lg:hidden"
      >
        <Text
          variant="h4"
          as="h4"
        >
          Distributor{distributorName ? `: ${distributorName}` : ''}
        </Text>
        <OperationsFilterAlt className="size-icon text-blue-500" />
      </button>
      <Modal
        heading="Distributor"
        description="Select the distributor that applies to your address. You can find your distributor on your energy bill."
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        openModal={openModal}
      >
        <BaseModalContent
          buttonComponent={<ModalButton onClick={closeModal}>Done</ModalButton>}
        >
          <DistributorField />
        </BaseModalContent>
      </Modal>
    </>
  );
};

export { DistributorFilterModal };
